const ELEMS = {
    cardWrapper: '.js-analytics-card-wrapper',
    cards: '.js-analytics-card',
    activeSkeletonClass: 'skeleton-card',
};

let newSkeletonCards = [];

function skeletonInit(data) {
    const cards = document.querySelectorAll(ELEMS.cards);
    const cardsWrapper = document.querySelector(ELEMS.cardWrapper);

    if (data) {
        cards.forEach((card) => {
            const cardHeight = card.offsetHeight;
            const cardWidth = card.offsetWidth;
            const skeletonCard = document.createElement('div');

            skeletonCard.classList.add('m-system-analys-review-block-card');
            skeletonCard.classList.add(ELEMS.activeSkeletonClass);
            skeletonCard.style.height = `${cardHeight}px`;
            skeletonCard.style.width = `${cardWidth}px`;

            newSkeletonCards.push(skeletonCard);
            card.remove();
        });
        newSkeletonCards.forEach((skeletonCard) => {
            cardsWrapper.appendChild(skeletonCard);
        });
    } else {
        const skeletonCards = document.querySelectorAll(`.${ELEMS.activeSkeletonClass}`);
        skeletonCards?.forEach((card) => {
            card.remove();
        });
        newSkeletonCards = [];
    }
}

function createCard(cardData, cardsWrapper) {
    const { name, file, icon } = cardData;
    const card = document.createElement('a');
    const cardText = document.createElement('span');
    const cardIcon = document.createElement('img');
    card.classList.add('m-system-analys-review-block-card');
    card.classList.add('js-analytics-card');
    card.setAttribute('href', file);
    card.setAttribute('target', '_blank');
    cardText.classList.add('m-system-analys-review-block-card__name');
    cardText.textContent = name;
    cardIcon.classList.add('m-system-analys-review-block-card__img');
    cardIcon.setAttribute('src', icon);
    cardIcon.setAttribute('alt', name);
    card.appendChild(cardText);
    card.appendChild(cardIcon);
    cardsWrapper.appendChild(card);
}

function setAnalyticsCard(payload) {
    const cardsWrapper = document.querySelector(ELEMS.cardWrapper);

    if (!cardsWrapper) {
        console.error(`В DOM не найдено обертка ${ELEMS.cardWrapper}`);
        return false;
    }

    payload?.forEach((cardData) => {
        createCard(cardData, cardsWrapper);
    });
}

export { setAnalyticsCard, skeletonInit };
